import * as React from 'react';
import ExportCSV from '../../sys/exportCSV';
import { default as Renderers } from '../../sys/columns';
import DatePicker from 'react-datepicker';
import { Input, Dropdown, Button } from 'semantic-ui-react';
import CustomPagination from '../../sys/pagination';
import OAuth, { OAuthClientStatus, DataRequest, TimeRange } from '../../api';
import ReactTable from 'react-table';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-table/react-table.css';
import * as ReactTooltip from 'react-tooltip';
import * as moment from 'moment';

const _ = require('lodash');

class State {
    groupby: Array<string>;
    startDate?: any;
    endDate?: any;
    alarmFilter: any;
    severityFilter: any;
    objectFilter: any;
    detailFilter: any;
    csvData: any;
    doRefresh: boolean;
    buttonText: string;
    refresh ?: number;
    firstLoad ?: boolean;
}

interface Props {
    location ?: any;
    streamName ?: string;
    header ?: boolean;
}

export default class AlarmLogView extends React.Component<Props, State> {
    public static defaultProps: Partial<Props> = {
        location: { state: { name: 'WebVTT'}},
        streamName: '',
        header: true
    };

    protected columns = [
        {
            Header: 'Alarm Time',
            accessor: 'timestamp',
            width: 180,
            headerStyle: { textAlign: 'left' },
            aggregate: (values: any, row: any) => (values.length > 0) ? { min: _.min(values), max: _.max(values) } : null,
            Cell: (props: any) => Renderers.timestamp.format(props.value),
            Aggregated: (row: any) => (
                <span className="aggregated-timestamp">
                        {Renderers.timestamp.format(row.value.min)} to {Renderers.timestamp.format(row.value.max)}
                    </span>
            )
        }, {
            Header: 'Alarm',
            accessor: 'alarmName',
            width: 220,
            headerStyle: { textAlign: 'left' },
            Cell: (props: any) => this.alarmNameRenderer(props),
        }, {
            Header: 'Level',
            accessor: 'severity',
            width: 150,
            headerStyle: { textAlign: 'left' },
            Cell: (props: any) => this.severityRenderer(props)
        }, {
            Header: 'Object',
            accessor: 'detail.name',
            headerStyle: { textAlign: 'left' },
            width: 300,
            Cell: (props: any) => this.nameRenderer(props.value),
            Aggregated: (row: any) => { return null; }
        }, {
            Header: 'Type',
            accessor: 'detail.streamType',
            headerStyle: { textAlign: 'left' },
            width: 200,
            resizable: false,
            Cell: (props: any) => Renderers.streamType(props.value),
            Aggregated: (row: any) => null
        }, {
            Header: 'Host',
            accessor: 'detail.url',
            headerStyle: { textAlign: 'left' },
            width: 300,
            resizable: false,
            Cell: (props: any) => this.hostUrlRenderer(props.value),
            Aggregated: (row: any) => null
        }, {
            Header: 'Media IP Address',
            accessor: 'detail.mediaIp',
            headerStyle: { textAlign: 'left' },
            width: 300,
            Cell: (props: any) => this.mediaIpRenderer(props.value),
            Aggregated: (row: any) => { return null; }
    }];

    toggleRefreshHandler = () => {
        const doesRefresh = this.state.doRefresh;
        let btnText = this.state.buttonText;
        if (btnText === 'Update') {
            btnText = 'Pause';
        } else {
            btnText = 'Update';
        }

        this.setState( {
            doRefresh: !doesRefresh,
            buttonText: btnText
        } );
    }
    
    componentWillMount() {
        Renderers.ReactTable(this.columns);
        this.setState({
            refresh: 10000,
            groupby: [],
            startDate: '',
            endDate: '',
            alarmFilter: '',
            severityFilter: '',
            objectFilter: '',
            detailFilter: '',
            csvData: [],
            doRefresh: true,
            buttonText: 'Pause',
            firstLoad: true
        });
        this.setRefreshInterval = this.setRefreshInterval.bind(this);
    }

    setRefreshInterval(interval?: number) {
        this.setState({ refresh: interval });
    }

    componentDidMount() {
        this.setObjectFilterOnFirstLoad();
    }

    tooltipRenderer() {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={250} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }

    nameRenderer(value: any): React.ReactNode {
        return (
            <div data-tip={value}>
                {this.tooltipRenderer()}
                {value}
            </div>
        );
    }

    mediaIpRenderer(value: any): React.ReactNode {
        return (
            <div data-tip={value}>
                {value}
            </div>
        );
    }

    changeStream(streamName: string) {
        this.setState( {firstLoad: false, objectFilter: streamName } );
    }

    setObjectFilterOnFirstLoad() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);
        
        const { location } = this.props;
        // tslint:disable-next-line:no-unused-expression
        (this.state.firstLoad && location && location.state && location.state.name) && this.setState({objectFilter: location.state.name});
        // tslint:disable-next-line:no-unused-expression
        (this.state.firstLoad && this.props.streamName) && this.setState({objectFilter: this.props.streamName});
    }
    render() {
        const { location } = this.props;
        const { startDate, endDate, alarmFilter, severityFilter, detailFilter, doRefresh, buttonText } = this.state;
        const objectFilter = (this.state.firstLoad && location && location.state && location.state.name) ? location.state.name : this.state.objectFilter;
        const levelOptions = [ { value: 'all', text: 'ALL' },
                                { value: 'info', text: 'INFO' },
                                { value: 'warning', text: 'WARNING' },
                                { value: 'minor', text: 'MINOR' },
                                { value: 'major', text: 'MAJOR' },
                                { value: 'critical', text: 'CRITICAL' }];
        let params;
        if ((objectFilter.startsWith('\'') && objectFilter.endsWith('\'')) || (objectFilter.startsWith('\"') && objectFilter.endsWith('\"'))) {
            let tmpFilter = objectFilter.slice(1, objectFilter.length - 1);
            params = {
                timerange: new TimeRange({from: startDate, to: endDate}),
                alarm: alarmFilter.toUpperCase(),
                severity: severityFilter,
                exactName: tmpFilter,
                detail: detailFilter
            };
        } else {
            params = {
                timerange: new TimeRange({from: startDate, to: endDate}),
                alarm: alarmFilter.toUpperCase(),
                severity: severityFilter,
                name: objectFilter,
                detail: detailFilter
            };
        }
        
        return (
            <div className="view-content" id="alarmlog">
                {(this.props.header === true) ?
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Alarm Log</div>
                        </div>
                    </div>
                </div> : ''}
                {(this.props.header === true) ?
                <OAuth.Context>{(oauth: OAuthClientStatus) => (
                    <div className="filterPanel">
                        <DatePicker
                            className="datePicker1SearchBox"
                            todayButton={'Today'}
                            placeholderText={'Start Time'}
                            selected={startDate}
                            value={this.state.startDate ? moment(this.state.startDate).format('LLL') : undefined}
                            onChange={(date) => this.setState({startDate: date})}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="LLL"
                            isClearable={this.state.startDate ? true : false}
                        />
                        <DatePicker
                            className="datePicker2SearchBox"
                            todayButton={'Today'}
                            placeholderText={'End Time'}
                            selected={endDate}
                            value={this.state.endDate ? moment(this.state.endDate).format('LLL') : undefined}
                            onChange={(date) => this.setState({endDate: date})}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="LLL"
                            isClearable={this.state.endDate ? true : false}
                        />
                        <Input
                            className="filterPanelSearchBox"
                            placeholder="Alarm"
                            value={alarmFilter}
                            onChange={(event, data) => this.setState({alarmFilter: data.value})}
                        />
                        <Dropdown
                            className="alarmLogDropDown"
                            placeholder="Level"
                            value={severityFilter}
                            search
                            selection
                            options={levelOptions}
                            onChange={(event, data) => this.setState({severityFilter: data.value})}
                        />
                        <React.Fragment>
                            <Input
                                className="objectPanelSearchBox"
                                placeholder="Object"
                                value={objectFilter}
                                onChange={(event, data) => this.changeStream(data.value)}
                            />
                        </React.Fragment>
                        <Input
                            className="filterPanelSearchBox"
                            placeholder="Detail"
                            value={detailFilter}
                            onChange={(event, data) => this.setState({detailFilter: data.value})}
                        />
                         <div className="spacer"/>
                        {/*<Button className="filterPanel-primary-btn" content="Filter" onClick={() => this.handleFilter()}/>*/}
                        <Button className="filterPanel-secondary-btn" content="Reset" onClick={() => this.handleReset()}/>
                        <Button className="filterPanel-right-primary-btn" content={buttonText} onClick={this.toggleRefreshHandler}/>
                        <ExportCSV
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            alarmFilter={this.state.alarmFilter}
                            severityFilter={this.state.severityFilter}
                            objectFilter={this.state.objectFilter}
                            detailFilter={this.state.detailFilter}
                        />
                    </div>
                )}</OAuth.Context> : ''}
                <div className="view-clientarea">
                    <DataRequest
                        auto                // automatically request on data change (filter change)
                        spinner             // show spinner when foreground loading (ex. on first load)
                        debounce={1500}      // debounce multiple requests (i.e. as user types in filter box)
                        interval={this.state.refresh}  // update every 10 seconds
                        method="get"
                        endpoint="api/log/alarm"
                        paused={!doRefresh}
                        params={params}
                    >
                    { (request: any) => {
                        // render a react table using the request data
                        return <ReactTable
                            className="transaction-log -striped -highlight outside-scroll"
                            pivotBy={this.state.groupby}
                            onFetchData={request.refresh}
                            data={(request.data && request.data.entries) || []}
                            columns={this.columns}
                            defaultPageSize={16}
                            PaginationComponent={CustomPagination}
                            NoDataComponent={request.spinner ? () => null : undefined}
                            collapseOnDataChange={false}
                            defaultSorted={[
                                {
                                    id: 'timestamp',
                                    desc: true
                                }
                            ]}
                            SubComponent={(row: any) => {
                                let template = this.detailRenderer(row);
                                return (
                                    <div>{template}</div>
                                );
                            }}
                        />;
                    }}
                    </DataRequest>
                </div>
            </div>
        );
    }

    rawRenderer(value: string) {
        if (value) {
            let length = value.split('_')[0].length;
            return value.split('_')[0].substring(1, length - 1);
        }
        return null;
    }

    detailRenderer(props: any) {
        let url = (props.original.detail.url ? props.original.detail.url.split('/') : null);
        let indexUrl = '';
        if (url != null) {
            url.splice(0, 1);
            indexUrl = url.toString().replace(/,/g, '/');
        }
        let currentValue = '';
        let threshold = '';
        let level = '';
        let err = '';

        Object.keys(props.original.detail).forEach(key => {
            if (key.endsWith('cur')) {
                currentValue = props.original.detail[key];
            }
            if (key.endsWith('thr')) {
                threshold = props.original.detail[key];
            }
            if (key.endsWith('lvl') || key.endsWith('Lvl')) {
                level = props.original.detail[key];
            }
            if (key.endsWith('err') || key.endsWith('err')) {
                err = props.original.detail[key];
            }
        });

        let streamType = (value: any, name: String) => value !== null ?  <td className="word-wrap" data-label={name} data-tip={value}>{value}</td> : null;
        return (
            <div className="template">
                <table className="table-large fixed-table">
                    <thead>
                        <tr>
                            <th>Asset</th>
                        </tr>
                    </thead>
                        <tbody>
                            {(props.original.detail && props.original.detail.conntimemax) &&
                            <tr>
                                {streamType(indexUrl !== '' ? indexUrl : null,  'Playlist: ')}
                                {streamType(props.original.detail.conntimemax, 'conntimemax')}
                                {streamType(props.original.detail.dnsTimeMax, 'dnsTimeMax')}
                            </tr>}
                            {(props.original.detail && props.original.detail.audiosilenchanactive) &&
                            <tr>
                                {streamType(indexUrl !== '' ? indexUrl : null,  'Playlist: ')}
                                {streamType(props.original.detail.audiosilenchanactive, 'Silence Channel Active')}
                                {streamType(props.original.detail.audiosilenchanalarm, 'Silence Channel Alarm Mask')}
                            </tr>}
                            <tr>
                                {streamType(indexUrl !== '' ? indexUrl : null,  'Playlist: ')}
                            </tr>
                        </tbody>
                </table>
                <table className="table-small">
                    <thead>
                        <tr>
                            <th>Alarm</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {streamType(props.original.detail.flowFlt ? props.original.detail.flowFlt : null, 'Alarm Template')}
                            {streamType(props.original.detail.value >= 0 ? props.original.detail.value : null, 'Alarm Value')}
                            {streamType(props.original.detail.threshold >= 0 ? props.original.detail.threshold : null, 'Alarm Threshold')}
                            {streamType(currentValue === '' ? null : currentValue, 'Current Value')}
                            {streamType(threshold === '' ? null : threshold, 'Threshold')}
                            {streamType(level === '' ? null : level, 'Level')}
                            {streamType(err === '' ? null : err, 'Error')}
                            {streamType(props.original.detail.timeIvl ? props.original.detail.timeIvl : null, ' Time Interval')}
                            {streamType(props.original.detail.segmentationTypeId ? props.original.detail.segmentationTypeId : null, 'Segmentation Type Id')}
                            
                        </tr>
                        </tbody>
                </table>
                {(!props.original.name && props.original.alarmName === 'LINK-UP') &&
                <table className="table-small">
                    <thead>
                        <tr>
                            <th>Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {streamType(props.original.detail ? this.rawRenderer(props.original.detail.raw) : null, '')}
                        </tr>
                    </tbody>
                </table>}
                {(!props.original.name && props.original.alarmName === 'SYS-OTGE') &&
                <table className="table-small">
                    <thead>
                        <tr>
                            <th>Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {streamType(props.original.detail && props.original.detail.totalSeconds ? props.original.detail.totalSeconds : null, 'Total Seconds')}
                            {streamType(props.original.detail && props.original.detail.streamcount ? props.original.detail.streamcount : null, 'Stream Count')}
                        </tr>
                    </tbody>
                </table>}
            </div>
        );
   }

    // objectRenderer(props: any): React.ReactNode {
    //     let asset = '';
    //     let profile = '';
    //
    //     if (props.original.detail.assetName !== undefined) {
    //         asset = props.original.detail.assetName;
    //     }
    //     if (props.original.detail.profileName !== undefined && props.original.detail.profileName !== '') {
    //         if (asset !== '') {
    //             profile = '-' + props.original.detail.profileName;
    //         } else {
    //             profile = props.original.detail.profileName;
    //         }
    //     }
    //
    //     let value = asset + profile;
    //
    //     return <div title={value}>{value}</div>;
    // }

    severityRenderer(props: any): React.ReactNode {
        return (
            <div data-tip={props.value.toUpperCase()}>
                {props.value.toUpperCase()}
            </div>);
    }

    alarmNameRenderer(props: any): React.ReactNode {
        let longname = '';
        let clsName = 'eventType';

        if (props.value.startsWith('SYN-')) {
            props.value = props.value.slice(4);
        }
        switch (props.value) {
            case 'VIDO-NEW':
                longname = 'New Video Stream Detected';
                break;
            case 'VIDO-LOS':
                longname = 'Video Stream Outage';
                break;
            case 'LINK-UP':
                longname = 'LINK UP and Speed Change';
                break;
            case 'CONN-TIME':
                longname = 'Connection Time Error limit';
                break;
            case 'CONN-TIME-15':
                longname = 'Connection Time Error 15-Min Limit';
                break;
            case 'CONN-TIME-MAX':
                longname = 'Connection Time upper Limit Crossed';
                break;
            case 'DNS-TIME':
                longname = 'DNS Request Time Error limit';
                break;
            case 'DNS-TIME-15':
                longname = 'DNS Request Time Error 15-Min Limit';
                break;
            case 'DNS-TIME-MAX':
                longname = 'DNS Request Time Upper Limit Crossed';
                break;
            default:
                longname = props.value;
        }

        if (props.original.eventStatus === 'clear') {
            clsName = 'iq-td-status-clear';                     // clear is green
        } else if (props.value === 'OUTAGE') {
            clsName = 'iq-td-status-outage';                    // outage is black
        } else
        if (props.original.eventStatus === 'set') {
            if (props.original.severity === 'info') {
                    clsName = 'iq-td-status-info';              // info is white
            }
            if (props.original.severity === 'warning') {
                    clsName = 'iq-td-alarm-critical';           // All other alarms are red because SABR only has severity of outage alarms as 'critical'.
            } else                                              // But since outage alarms are black, we use red for others.
                if (props.original.severity === 'minor') {
                    clsName = 'iq-td-alarm-critical';           // This is inconsistent from IVMS-AMS since they use red for critical and use orange for both major and minor.
            } else                                              // Inspector on the other hand has only green for clear and red for set.
                if (props.original.severity === 'major') {
                    clsName = 'iq-td-alarm-critical';
            } else
                if (props.original.severity === 'critical') {
                    clsName = 'iq-td-alarm-critical';
            }
        }
        return <div className={clsName} data-tip={longname}>{props.value}</div>;
    }

    hostUrlRenderer(props: any): React.ReactNode {
        let hostUrl = (props ? props.split('/') : null);

        return (
            <div data-tip={props ? hostUrl[0] : null}>
                {props ? hostUrl[0] : null}
            </div>
        );
    }

    handleFilter() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);
    }
    handleReset() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);

        this.setState({
            startDate: '',
            endDate: '',
            alarmFilter: '',
            severityFilter: '',
            objectFilter: '',
            detailFilter: ''
        });
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/logs/alarmlog.tsx